import {DomainObject} from 'shared/store';
import { computed, observable, makeObservable } from 'mobx';
import moment from 'moment';
import {t} from 'shared/core';

class Absence extends DomainObject {
  id;
  startTime;
  endTime;
  date;
  amount;

  _relations = {
    _dates: ['date']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      startTime: observable,
      endTime: observable,
      date: observable,
      amount: observable,
      timeRange: computed
    });

    this.merge(other);
  }

  get timeRange() {
    if (!this.startTime || !this.endTime) {
      return null;
    }

    return `${moment(this.startTime).format(t('components.dates.TIMESTAMP_FORMAT'))} - ${moment(this.endTime).format(t('components.dates.TIMESTAMP_FORMAT'))}`;
  }
}

export default Absence;
